import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function PieChartIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M12.535 9.333A6.005 6.005 0 1 1 4.603 1.49m7.949 3.21c.24.58.388 1.194.438 1.818.012.154.018.231-.012.3a.3.3 0 0 1-.132.144c-.067.036-.15.036-.317.036H7.485c-.168 0-.252 0-.316-.033a.3.3 0 0 1-.132-.131c-.032-.064-.032-.148-.032-.317V1.471c0-.166 0-.25.036-.317a.3.3 0 0 1 .143-.132c.07-.03.146-.024.3-.012a6 6 0 0 1 5.068 3.69" /></svg>
  );
}

export default PieChartIcon;
